import { FieldNameEnum } from "./FieldNameEnum";

export const fundEnumList = [
  FieldNameEnum.fund1,
  FieldNameEnum.fund2,
  FieldNameEnum.fund3,
  FieldNameEnum.fund4
];

export const fundCodeEnumList = [
  FieldNameEnum.fund1Code,
  FieldNameEnum.fund2Code,
  FieldNameEnum.fund3Code,
  FieldNameEnum.fund4Code
];

export const fundPercentEnumList = [
  FieldNameEnum.fund1Percent,
  FieldNameEnum.fund2Percent,
  FieldNameEnum.fund3Percent,
  FieldNameEnum.fund4Percent
];
